import { linesConfigGlobal, setBetValueGlobal } from "../config/GlobalVariableConfig";
import { getPositions, getValues } from "../utils";

// import { spinResponseDataGlobal } from "../config/GlobalVariableConfig";

// import { REEL_NUMBERS, setNumOfSymbolsPerReel } from "../config/reelConfig";
const numberUnit = 0.01; // in cents

const coinNumberUnit = 0.1; // in cents

export interface WinObject { // the object -how we want to use in our program 
    lineId: number | null;
    count: number;
    symbolId: number;
    winAmount: number;
    winSymbolPosistions: number[][] | null;
    winMultiplier: number;
    bonusWon: string;
}

export interface IFeatureData {
    featureName: string;
    reelHeightPerReel: number;
    refillSpinsCount: number;
    scarabWinData?: {
        winAmount: number;
        symbolId: number;
        winSymbolPosistions: number[][] | null;
    }
    scarabCollectData?: {
        accumulated: number;
        collected: number;
        remaining: number;
    }
}

export interface WildObject { // the object -how we want to use in our program 
    reelNum: number;
    posNum: number;
    positions: number[][];
}

export interface BattleObject { // the object -how we want to use in our program 
    reelNum: number;
    posNum: number;
    isWolfWin: boolean;
    multiplier: number;
}

interface spinLeftObject { // the object -how we want to use in our program 
    isReduceSpins: boolean;
    value: number;
}

export interface ITransCoin { // the object -how we want to use in our program 
    reelNum: number;
    posNum: number;
    value: number;
}

export interface IRevealCoin { // the object -how we want to use in our program 
    reelNum: number;
    posNum: number;
    id: number;
}

export interface ICollect { // the object -how we want to use in our program 
    feature: string;
    reelNum: number;
    posNum: number;
    value: number;
}

export interface IPos { // the object -how we want to use in our program 
    reelNum: number;
    posNum: number;
}

export interface IDouble { // the object -how we want to use in our program 
    feature: string;
    reelNum: number;
    posNum: number;
    values: number[][];
    positions: IPos[];
}

export interface IAdder { // the object -how we want to use in our program 
    feature: string;
    reelNum: number;
    posNum: number;
    values: number[][];
    positions: IPos[];
}

export interface RespinObject { // the object -how we want to use in our program 

    type: string;
    freeGameTrigger: number;
    reelSymbols: number[][];
    winLines: WinObject[] | null; // Making winLines optional because might be no win
    winScatters: WinObject[] | null;
    winAmount: number; // win of that particular cascade respin 
    multiplier: number; // accumulated multiplier applicable on  that particular respin 
    accumulatedsWinAmount: number; // win of that particular respin total


    coinCollect: number[][];
    initialCoinValues: number[][];
    coinValues: number[][];
    multiplierValues: number[][];
    multipliedCoinValues: number[][] | null;
    transformCoins: ITransCoin[];
    revealCoins: IRevealCoin[];
    collects: ICollect[];
    doubles: IDouble[];
    adders: IAdder[];
    spinLeft: spinLeftObject | null;
    featureData: IFeatureData | null;

}

export interface SpinDataObject { // the object -how we want to use in our program 

    dataFeatched: boolean;

    betAmount: number;

    // state value - kind of header
    freeGameTrigger: number; // number of fs won in base game
    freeGameReTrigger: number;  // number of fs won in free game
    totalFreeGame: number; // total number of fs - to show in counter 
    remainingFreeGame: number; // remaining number of fs - to show in counter 
    totalAccumulatedWin: number; // used specially in free games
    totalWin: number;  // win of current spin including all respins
    balance: number;
    isWinHigherBet: boolean;
    triggerFeatures: string[];
    isMaxwinJackpotWon: boolean;
    respins: RespinObject[];

};



export const spinData: SpinDataObject = { // use in other class

    dataFeatched: false,

    betAmount: 0,
    freeGameTrigger: 0,
    freeGameReTrigger: 0,
    totalFreeGame: 0,
    remainingFreeGame: 0,
    totalAccumulatedWin: 0,
    totalWin: 0,
    balance: 0,
    isWinHigherBet: false,
    triggerFeatures: [],
    isMaxwinJackpotWon: false,
    respins: []
};

export function resetSpinData(): void {
    spinData.dataFeatched = false;

    spinData.freeGameTrigger = 0;
    spinData.freeGameReTrigger = 0;
    spinData.totalFreeGame = 0;
    spinData.remainingFreeGame = 0;
    spinData.totalAccumulatedWin = 0;
    spinData.totalWin = 0;
    spinData.balance = 0;
    spinData.isWinHigherBet = false;

    spinData.respins = [];
}


// export async function spinResponse(): Promise<void> {

//     console.log('insidespinResponse');

//     parserSpinResponse(spinResponseDataGlobal);

// }


export function parserSpinResponse(data: any): void {
    console.log("inside parserSpinResponse", data);



    // Initialize the SpinDataObject
    spinData.dataFeatched = true;

    spinData.betAmount = Number(data.betAmountString) / 100;
    setBetValueGlobal(spinData.betAmount);

    if (Number(data.latestWinString) > Number(data.betAmountString)) {
        spinData.isWinHigherBet = true;
    } else {
        spinData.isWinHigherBet = false;
    }


    let triggerFeatures: string[] = [];

    //let multiplierValuesSoFar: number[][] = [];

    data.events.forEach((event: any) => {

        let REEL_NUMBERS = 0;
        let SYMBOLS_PER_REEL = 0;
        let reelSymbols: number[][] = [];

        if (event.c?.grid) {
            const decoded = decodeGrid(event.c.grid);
            reelSymbols = decoded.array;
            REEL_NUMBERS = decoded.width;
            SYMBOLS_PER_REEL = decoded.height;
        } else {
            reelSymbols = [];
            REEL_NUMBERS = 0;
            SYMBOLS_PER_REEL = 0;
        }
        // console.log(reelSymbols);

        //initialize the greenCollect, blueCollect, pinkCollect, coinValues with 0


        let coinValues: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL).fill(0)
        );

        const coinCollect: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL).fill(0)
        );
        const transformCoins: ITransCoin[] = [];
        const revealBonusCoins: IRevealCoin[] = [];
        const collectPoseidon: ICollect[] = [];
        const doubleHades: IDouble[] = [];
        const adderZeus: IAdder[] = [];
        let respinWinAmount = Number((event.wa * numberUnit).toFixed(2)); // Total win of that particular respin
        // console.log(winAmount);

        let accumWinAmount = Number((event.awa * numberUnit).toFixed(2)); // Total win of that particular respin

        let totalMultiplier = 1;

        const type = event.etn === "fs_2_reveal" ? "fs_reveal" : event.etn;

        let spinLeft = null;

        // // // Check for feature spin (e.g., free game trigger)
        let freeGameTrigger = 0;
        if (event.etn === "feature_enter") {
            freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.totalFreeGame = Number(event.c.bonusFeatureCount) || 0;
            spinData.triggerFeatures = triggerFeatures;

        }

        const winLines: WinObject[] = [];
        const winScatters: WinObject[] = [];


        event.c && event.c.actions?.forEach((action: any) => {

            if (action.at === "bonusfeaturewon") {
                const triggerFeaturesBackend = action.data.features; //'zeus', 'hades', 'poseidon'

                const preferredNameSeq = ['zeus', 'hades', 'poseidon'];
                preferredNameSeq.forEach((feature) => {
                    if (triggerFeaturesBackend.includes(feature)) {
                        triggerFeatures.push(feature);
                    }
                })
            }
            else if (action.at === "jackpot") {
                spinData.isMaxwinJackpotWon = true;
            } else if (action.at === "transformBonusCoin") {
                const p: number = Number(action.data.p);
                const transCoin: ITransCoin = {
                    reelNum: p % REEL_NUMBERS,
                    posNum: Math.floor(action.data.p / REEL_NUMBERS),
                    value: Number(action.data.v) * coinNumberUnit
                };
                transformCoins.push(transCoin);
            } else if (action.at === "revealBonusCoin") {
                const revealCoin: IRevealCoin = {
                    reelNum: action.data.p % REEL_NUMBERS,
                    posNum: Math.floor(action.data.p / REEL_NUMBERS),
                    id: action.data.i
                };
                revealBonusCoins.push(revealCoin);
            }
            else if (action.at === "coinValues") {
                // const values = action.data.v;
                // // Loop through the binary string and fill the 2D array conceptually
                // for (let i = 0; i < values.length; i++) {
                //     const p = Number(i);
                //     const reelNum = p % REEL_NUMBERS;          // Column number (reelId)
                //     const posNum = Math.floor(p / REEL_NUMBERS); // Row number (position)
                //     coinValues[reelNum][posNum] = Number(values[i]) * coinNumberUnit;
                // }
                coinValues = getValues(action.data.v);
            } else if (action.at === "collectPoseidon") {
                const p = Number(action.data.p);
                const zeus: ICollect = {
                    feature: "collect",
                    reelNum: p % REEL_NUMBERS,
                    posNum: Math.floor(p / REEL_NUMBERS),
                    value: Number(action.data.v)
                };
                collectPoseidon.push(zeus);
            } else if (action.at === "doubleHades") {
                const p = Number(action.data.p);
                const double: IDouble = {
                    feature: "double",
                    reelNum: p % REEL_NUMBERS,
                    posNum: Math.floor(p / REEL_NUMBERS),
                    values: getValues(action.data.v),
                    positions: getPositions(action.data.doubledPositions)
                };
                doubleHades.push(double);
            } else if (action.at === "adderZeus") {
                const p = Number(action.data.p);
                const adder: IAdder = {
                    feature: "adder",
                    reelNum: p % REEL_NUMBERS,
                    posNum: Math.floor(p / REEL_NUMBERS),
                    values: getValues(action.data.v),
                    positions: getPositions(action.data.addedPositions)
                };
                adderZeus.push(adder);
            }
            else if (action.at === "reduceLife") {
                const spinLeftVal: spinLeftObject = {
                    isReduceSpins: true,
                    value: Number(action.data.v)
                };
                spinLeft = spinLeftVal;
            }
            else if (action.at === "refillLives") {
                const spinLeftVal: spinLeftObject = {
                    isReduceSpins: false,
                    value: Number(action.data.v)
                };
                spinLeft = spinLeftVal;
            }
            else if (action.at === "gridwin") { // Handling win lines or win scatters
                const symbolId = Number(action.data.symbol);

                const winAmount = Number(action.data.winAmount * numberUnit);
                const winSymbolPositions = action.data.mask ? getReelPositions(action.data.mask, REEL_NUMBERS) : [];
                const winMultiplier = action.data.winMultipliers ? Number(action.data.winMultipliers[0]) : 1;
                const bonusWon = action.data.bonusWon || ""; // Assuming you want to track bonus wins
                const count = Number(action.data.count)

                const lineId = getLineId(winSymbolPositions, count);


                const winObject: WinObject = {
                    lineId,
                    count,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                if (symbolId === 22222) { // Assuming symbol 15 is a scatter
                    winScatters.push(winObject);
                } else {
                    winLines.push(winObject);
                }
            }


        });

        // Create the RespinObject and push it to spinData.respins
        const respin: RespinObject = {
            type: type,
            freeGameTrigger: freeGameTrigger,
            reelSymbols: reelSymbols,
            winLines: winLines.length > 0 ? winLines : null,
            winScatters: winScatters.length > 0 ? winScatters : null,
            winAmount: respinWinAmount,
            multiplier: totalMultiplier,
            accumulatedsWinAmount: accumWinAmount,

            coinCollect: coinCollect,
            initialCoinValues: [],
            coinValues: coinValues,
            multiplierValues: [],
            multipliedCoinValues: [],
            transformCoins: transformCoins,
            revealCoins: revealBonusCoins,
            collects: collectPoseidon,
            doubles: doubleHades,
            adders: adderZeus,
            spinLeft: spinLeft,
            featureData: null
        };

        spinData.respins.push(respin);


    });

    console.log("Parsed spin data:", spinData);

}


function decodeGrid(grid: string): { array: number[][]; width: number, height: number } {
    const offset = 40; // ASCII offset for encoding

    // Extract width and height from the first two characters
    const width = grid.charCodeAt(0) - offset;
    const height = grid.charCodeAt(1) - offset;

    // Initialize the 2D array for storing the grid
    const gridArray = [];

    // Populate the 2D array with decoded values
    let index = 2; // Start from the third character
    for (let row = 0; row < height; row++) {
        const currentRow = [];
        for (let col = 0; col < width; col++) {
            // Convert each character to its decimal value using the offset
            const cellValue = grid.charCodeAt(index) - offset;
            currentRow.push(cellValue);
            index++;
        }
        gridArray.push(currentRow);
    }


    // console.log(gridArray);

    // Transpose the 2D array (swap rows with columns)
    const transposedArray = transposeMatrix(gridArray);

    // function to transpose a matrix (2D array)
    function transposeMatrix(matrix: number[][]) {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    }

    return { array: transposedArray, width, height };

}

function getReelPositions(binaryString: string, REEL_NUMBERS: number): [number, number][] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: [number, number][] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < binaryString.length; i++) {
        const reelId = i % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(i / REEL_NUMBERS); // Row number (position)

        if (binaryString[i] === '1') {
            result.push([reelId, positionNum]);
        }
    }

    return result;
}

export function getLineId(winSymbolPositions: number[][], count: number): number | null {
    // Create an array to represent the line structure from winSymbolPositions
    const positionsByReel: number[] = [];

    for (let i = 0; i < winSymbolPositions.length; i++) {
        const [reel, pos] = winSymbolPositions[i];
        positionsByReel[reel] = pos;
    }

    // Compare with each line in linesConfigGlobal
    for (let lineIndex = 0; lineIndex < linesConfigGlobal.length; lineIndex++) {
        const lineConfig = linesConfigGlobal[lineIndex];


        let match = true;
        for (let reel = 0; reel < count; reel++) {
            if (positionsByReel[reel] !== lineConfig[reel]) {
                match = false;
                break;
            }
        }

        if (match) return lineIndex;
    }

    return null; // No match found
}



